import { useState } from "react";
import { BsSearch } from "react-icons/bs";

import { Deal } from "@Types/deal";
import useDebounce from "@Hooks/useDebounce";
import useGlobalSearch from "@Hooks/useGlobalSearch";
import TextField from "@Components/Inputs/TextField";

import ResultsTable from "./ResultsTable";
import { ResultsTableProps, SearchState } from "./types";

import styles from "./Search.module.scss";

export const transformSearchToSearchTerm = (search: string) => {
  if (!search) return {};
  return search?.length > 3 ? { search: { term: search } } : {};
};
export const transformRequestDataToResultsTableProps = (requestData: {
  data: {
    deals: Deal[] | undefined;
  };
  isLoading: {
    dealsAreLoading: boolean;
  };
  error: {
    dealsError: unknown;
  };
}): ResultsTableProps<Deal> => {
  return {
    data: {
      data: requestData.data.deals,
      loading: requestData.isLoading.dealsAreLoading,
      error: requestData.error.dealsError,
    },
  };
};
const Search = () => {
  const [state, setState] = useState<SearchState>({ value: "", focus: false });
  const debouncedValue = useDebounce<SearchState>(state, 1000);
  const requestResult = useGlobalSearch(
    transformSearchToSearchTerm(debouncedValue.value)
  );
  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <BsSearch size={22} className={styles.icon} />
      </div>
      <div className={styles.textField}>
        <TextField
          value={state.value}
          inputStyle={{
            color: "#5E5D65",
            fontWeight: 400,
            borderTopRightRadius: 5,
            borderBottomRightRadius: 5,
            borderBottomLeftRadius: 0,
            borderTopLeftRadius: 0,
            border: 0,
            paddingLeft: "5px",
            boxShadow: "none",
          }}
          type="text"
          showPlaceHolderTop={false}
          placeholder="Search"
          onChange={(e) =>
            setState((prev) => ({ ...prev, value: e.target.value }))
          }
          onFocus={() => setState((prev) => ({ ...prev, focus: true }))}
          onBlur={() => setState((prev) => ({ ...prev, focus: false }))}
        />
      </div>
      {state.focus && state.value.length > 3 && (
        <ResultsTable
          {...transformRequestDataToResultsTableProps(requestResult)}
          setFocus={(focus) => setState((prev) => ({ ...prev, focus }))}
        />
      )}
    </div>
  );
};
export default Search;
